import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tooltip from "@mui/material/Tooltip";
import AlertIcon from "@mui/icons-material/Warning";
import IconButton from "@mui/material/IconButton";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Swal from 'sweetalert2';
import { ToastContainer, toast } from "react-toastify";
import {
  add_new_bal_sabha_member,
  get_bal_sabha_members_data,
  disable_mahila_bal_sabha_member,
  delete_mahila_bal_sabha_member,
  update_mahila_bal_sabha_member,
  freeze_members,
  get_committee_mahila_bal_freeze_data,
} from "../../api/User";
import "../Admin/table.css"

const ManageBalSabha = ({ committeName, memberType }) => {
  const [errors, setErrors] = useState({});
  const userId = sessionStorage.getItem("user_id");
  const role_id = sessionStorage.getItem("role_id");
  const gpID = sessionStorage.getItem("gp_data") || "";
  const [formData, setFormData] = useState({
    id: userId,
    committee_type: "",
    member_type: "",
    member_name: "",
    mobile_no: "",
  });
  const [formErrors, setFormErrors] = useState({
    committee_type: "",
    member_type: "",
    member_name: "",
    mobile_no: "",
  });

  const [filteredData, setFilteredData] = useState([]);
  const [rows, setRows] = useState([]);
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  const [filterModifyData, setFilteredDataModify] = useState([]);
  const [filteredFreezeData, setFilteredDataFreeze] = useState([]);
  const [othersInput, setOthersInput] = useState(false);
  const [memberTypeState, setMemberTypeState] = useState(memberType || []);
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [editData, setEditData] = useState(null);
  const [MemberTypeErr, setMemberTypeErr] = useState("");
  const [validateFormData, setvalidateFormData] = useState("");
  const originalColor = "#323576";
  const clickedColor = "#5E63C7";

  const [activeButton, setActiveButton] = useState(null);
  const [isFreezeVisible, setIsFreezeVisible] = useState(false);
  const [isTableVisible, setIsTableVisible] = useState(true);
  const [isModifyVisible, setIsModifyVisible] = useState(false);
  const navigate = useNavigate();
  const fetchDataFreeze = async (ID) => {
    const data = {
      id: userId,
      type: 'bal'
    };
    try {
      const res = await get_committee_mahila_bal_freeze_data(token, data);
      console.log(res);
      if (res.status === "success") {
        const freez = res.data.filter((item) => {
          return item.is_active == 1
        })
        setFilteredDataFreeze(freez);

      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };
  const fetchData = async () => {

    const data = {

      id: userId,

    };
    try {
      const res = await get_bal_sabha_members_data(token, data);
      console.log(res);
      if (res.status === "success") {
        const modify = res.data.filter((item) => {
          return item.is_active == 1 && item.is_freeze == 0
        })
        const freez = res.data.filter((item) => {
          return item.is_active == 1
        })
        setFilteredData(res.data);
        setFilteredDataModify(res.data);

      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };

  useEffect(() => {
    fetchData();
    fetchDataFreeze();
  }, []);
  const handleEditSubmit = async (event) => {
    event.preventDefault();
    const errors = {
      committee_type: editData.committee_type ? "" : "Committee Name is required.",
      member_type: editData.member_type ? "" : "Member Type is required.",
      member_name: editData.member_name ? "" : "Member Name is required.",
      mobile_no: validateMobileNo(editData.mobile_no),
    };
    setErrors(errors);

    const hasErrors = Object.values(errors).some((error) => error !== "");
    if (hasErrors) {
      return;
    }

    try {
      const res = await update_mahila_bal_sabha_member(token, editData);
      if (res.status === "success") {
        toast.success(res.message);
        fetchData();
        setOpenEditModal(false);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("Error updating record:", error);
      toast.error("An error occurred while updating the record.");
    }
  };
  const validateMobileNo = (mobile_no) => {
    if (!mobile_no) return "Mobile Number is required.";
    if (!/^\d{10}$/.test(mobile_no)) return "Mobile Number must be exactly 10 digits.";
    if (mobile_no[0] === '0') return "Mobile Number cannot start with zero.";
    if (/^0{10}$/.test(mobile_no)) return "Mobile Number cannot be all zeros.";
    return "";
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "mobile_no") {
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      setFormData((prevState) => ({
        ...prevState,
        [name]: numericValue,
      }));
      setFormErrors((prevState) => ({
        ...prevState,
        [name]: validateMobileNo(numericValue),
      }));
    } else if (name === "member_name") {
      const uppercaseValue = value.toUpperCase();
      const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, '');

      setFormData((prevState) => ({
        ...prevState,
        [name]: cleanedValue,
      }));

      setFormErrors((prevState) => ({
        ...prevState,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    if (name === "committee_type") {
      setOthersInput(value === "Any other Committee");
    }
  };

  const handleEdit = (ID) => {
    const selectedData = filteredData.find(item => item.id === ID);
    const committee_type = !committeName.includes(selectedData.committee_type);

    if (selectedData) {
      setEditData({
        ...selectedData,
        committee_type: committee_type ? "Any other Committee" : selectedData.committee_type,
        committeName: committee_type ? selectedData.committee_type : "",
      })
      setOthersInput(committee_type);
      setOpenEditModal(true);
    } else {
      console.error("Data with the given ID not found");
    }
  };



  const handleEditChange = (event) => {
    const { name, value } = event.target;
    const updatedValue =
      name === "mobile_no"
        ? value.replace(/\D/g, "").slice(0, 10)
        : name === "member_name"
          ? value.toUpperCase().replace(/[^A-Z\s]/g, "")
          : value;

    setEditData((prevState) => ({
      ...prevState,
      [name]: updatedValue,
    }));
    if (name === "committee_type") {
      setOthersInput(value === "Any other Committee");
    }
    setErrors((prevState) => ({
      ...prevState,
      [name]: name === "mobile_no" ? validateMobileNo(updatedValue) : "",
    }));
  };
  const handleDisableButton = async (is_active, ID) => {
    console.log(is_active, ID);
    if (is_active == 0) {
      is_active = 1;
    } else if (is_active == 1) {
      is_active = 0;
    }
    const data = {
      id: ID,
      is_active: is_active,
    };
    const res = await disable_mahila_bal_sabha_member(token, data);
    if (res.status == "success") {
      toast.success("Updated successfully", { autoClose: 1000 });
      fetchData();
      fetchDataFreeze();
    } else {
      toast.error("An error occurred while updating the item.", { autoClose: 1000 });
    }
  };
  const handleReset = () => {
    setFormData({
      id: userId,
      committee_type: "",
      committeName: "",
      member_type: "",
      member_name: "",
      mobile_no: "",
    });
    setFormErrors({
      committee_type: "",
      member_type: "",
      member_name: "",
      mobile_no: "",
    });
  };
  const handleDelete = (index) => {
    // SweetAlert confirmation dialog
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleConfirmDelete(index);  // Proceed with deletion if confirmed
      }
    });
  };
  
  const handleConfirmDelete = async (index) => {
    if (index !== null) {
      try {
        const updatedData = {
          id: filteredData[index].id,
        };
        const res = await delete_mahila_bal_sabha_member(token, updatedData);
        console.log("Delete response:", res);
        
        if (res.status === "success") {
          const updatedFilteredData = filteredData.filter((_, i) => i !== index);
          setFilteredData(updatedFilteredData);
          fetchData();
          toast.success("Deleted successfully", { autoClose: 1000 });
        } else {
          toast.error("An error occurred while deleting the item.", { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        toast.error("An error occurred while deleting the item.");
      }
    }
    setOpenDialog(false);
  };
  const handleToggleActive = async (index) => {
    const updatedData = filteredData.map((row, i) =>
      i === index ? { ...row, is_active: row.is_active === 1 ? 0 : 1 } : row
    );
    setFilteredData(updatedData);

    try {
      const res = await disable_mahila_bal_sabha_member(token, { id: filteredData[index].id, is_active: updatedData[index].is_active });
      if (res.status === "success") {
        toast.success("Updated successfully");
      } else {
        toast.error("An error occurred while updating the item.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("An error occurred while updating the item.");
    }
  };
  const handleCancelDelete = () => {
    setOpenDialog(false);

  };
  const handleComitteeChange = (e) => {
    console.log(e.target.value);
    formData.committee_type = e.target.value
  };
  const handleButtonClick = (button) => {
    setActiveButton(prev => (prev === button ? null : button));
    if (button === 'view') {
      setIsTableVisible(prev => !prev);
      setIsModifyVisible(false);
      setIsFreezeVisible(false);
    } else if (button === 'modify') {
      setIsTableVisible(false);
      setIsModifyVisible(prev => !prev);
      setIsFreezeVisible(false);
    } else if (button === 'freeze') {
      setIsTableVisible(false);
      setIsModifyVisible(false);
      setIsFreezeVisible(prev => !prev);
    }
  }

  const handleConfirmFreeze = async (is_freeze, ID) => {
    const actionText = is_freeze === 1 ? "unfreeze" : "freeze";
    const result = await Swal.fire({
      title: 'Confirm Action',
      text: `Are you sure you want to ${actionText} this record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, ${actionText} it!`,
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      const newIsFreeze = is_freeze === 1 ? 0 : 1;

      const data = {
        id: ID,
        type: "bal",
      };

      try {
        const res = await freeze_members(token, data);
        if (res.status === "success") {
          const updatedRow = { ...rows.find(row => row.id === ID), is_freeze: newIsFreeze };

          setRows(prevRows =>
            prevRows.map(row =>
              row.id === ID ? updatedRow : row
            )
          );
          toast.success("Updated successfully", { autoClose: 1000 });
          fetchData();
          fetchDataFreeze(ID);
        } else {
          toast.error("An error occurred while updating the item.", { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error during freeze operation:", error);
        toast.error("An error occurred. Please try again.", { autoClose: 1000 });
      }
    }
  };
  return (
    <div className="container-fluid" style={{ height: "91vh" }}>
      <h2 className="pt-10" style={{ top: "0", left: "0", margin: "16px",fontWeight:"bold"}}>
      Bal Sabha
      </h2>

      <div className="d-flex justify-content-end">
		<div className="col-md-2 row mt-2">
		  <Button
		    variant="contained"
		    onClick={() => handleButtonClick('view')}
		    sx={{
          width: "70%",
          backgroundColor: activeButton === 'view' ? "#323576" : "#5E63C7", // Change based on active button
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "#323576", // Maintain hover effect
          },
        }}
		  >
		    {isTableVisible ? 'View' : 'View'}
		  </Button>
		</div>
		<div className="col-md-2 row mt-2">
		  <Button
		    variant="contained"
		    onClick={() => handleButtonClick('modify')}
		    sx={{
          width: "70%",
          backgroundColor: activeButton === 'modify' ? "#323576" : "#5E63C7", // Change based on active button
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "#323576", // Maintain hover effect
          },
        }}
		  >
		    {isModifyVisible ? 'Modify' : 'Modify'}
		  </Button>
		</div>
		<div className="col-md-2 row mt-2">
		  <Button
		    variant="contained"
		    onClick={() => handleButtonClick('freeze')}
        sx={{
          width: "70%",
          backgroundColor: activeButton === 'freeze' ? "#323576" : "#5E63C7", // Change based on active button
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "#323576", // Maintain hover effect
          },
        }}
		  >
		    {isFreezeVisible ? 'Freeze' : 'Freeze'}
		  </Button>
		</div>
	      </div>
      <div>{isTableVisible && (
        <div >
        <h4 style={{fontWeight:"bold",margin: "16px"}}>View Resources</h4>
        <hr style={{ margin: '20px 0', border: '2px solid #ddd' }} />
        <div style={{ overflowX: 'auto',maxHeight: '55vh', marginTop: '20px' }}>
          <Table aria-label="simple table" >
            <TableHead
              style={{
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "#d0ecf7",
              }}
            >
              <TableRow>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  SR NO.
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  COMMITTEES NAME
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  MEMBER TYPE
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  MEMBER NAME
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  MOBILE NUMBER
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  STATUS
                </TableCell>
              </TableRow>

            </TableHead>
            <TableBody>
              {filteredData.map((row, index) => (
                <TableRow
                  key={row.id}
                  style={{
                    backgroundColor: row.is_active == 0 ? " #ffcccc" : "none",
                  }}
                >
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                    {index + 1}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                    {row.committee_type}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                    {row.member_type}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                    {row.member_name}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                    {row.mobile_no}
                  </TableCell>
                  <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {row.is_freeze == 0 ? (
                        <Tooltip title="Unfreezed" arrow>
                          <span
                            variant="contained"
                            color="secondary"
                            onClick={() => handleDisableButton(row.id)}
                            style={{
                              width: '100px',
                              height: '40px',
                              marginRight: '8px',
                              color: 'purple',
                              fontWeight: 'bold',
                            }}
                          >
                            UNFREEZED
                          </span>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Freezed" arrow>
                          <span
                            variant="contained"
                            color="primary"
                            onClick={() => handleDisableButton(row.id)}
                            style={{
                              width: '100px',
                              height: '40px',
                              color: "blue",
                              fontWeight: 'bold',
                            }}
                          >
                            FREEZED
                          </span>
                        </Tooltip>
                      )}
                    </div>
                  </TableCell>

                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        </div>)}
      </div>
      <div>{isModifyVisible && (
        <div >
        <h4 style={{fontWeight:"bold",margin: "16px"}}>Modify Resources</h4>
        <hr style={{ margin: '20px 0', border: '2px solid #ddd' }} />
        <div style={{ overflowX: 'auto', maxHeight: '55vh', marginTop: '20px' }}>
          <Table aria-label="simple table">
            <TableHead
              style={{
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "#d0ecf7",
              }}
            >
              <TableRow>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  SR NO.
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  COMMITTEES NAME
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  MEMBER TYPE
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  MEMBER NAME
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  MOBILE NUMBER
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  ACTION
                </TableCell>
              </TableRow>

            </TableHead>
            <TableBody>
              {filterModifyData.map((row, index) => (
                <TableRow
                  key={row.id}
                  style={{
                    backgroundColor: row.is_active == 0 ? " #ffcccc" : "none",
                  }}
                >
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                    {index + 1}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                    {row.committee_type}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                    {row.member_type}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                    {row.member_name}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                    {row.mobile_no}
                  </TableCell>
                  <TableCell
                    style={{ whiteSpace: "nowrap", textAlign: "center" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Tooltip title="Edit" arrow>
                        <Button
                          onClick={() => handleEdit(row.id)}
                          size="small"
                          sx={{
                            color: "blue",
                            minWidth: "auto",
                            marginRight: "5px",
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </Button>
                      </Tooltip>
                      <Tooltip title="Delete" arrow>
                        <Button
                          onClick={() => handleDelete(index)}
                          size="small"
                          sx={{ color: "red", minWidth: "auto" }}
                        >
                          <DeleteIcon fontSize="small" />
                        </Button>
                      </Tooltip>
                      <tr
                        key={row.id}
                        style={{ backgroundColor: row.is_active === 0 ? "transparent" : "transparent" }}
                      >
                        <td>
                          <Tooltip title={row.is_active ? "Deactivate" : "Activate"} arrow>
                            <Switch
                              disabled={row.is_active === 0}
                              checked={row.is_active === 1}
                              onChange={() => handleDisableButton(row.is_active, row.id)}
                              color="default"
                              sx={{
                                "& .MuiSwitch-switchBase.Mui-checked": {
                                  color: "green",
                                },
                                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                  backgroundColor: "green",
                                },
                                "& .MuiSwitch-track": {
                                  backgroundColor: "red",
                                },
                              }}
                            />
                          </Tooltip>
                        </td>
                      </tr>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        </div>)}
      </div>
      <div>
        {isFreezeVisible && (
          <div >
          <h4 style={{fontWeight:"bold",margin: "16px"}}>Freeze Resources</h4>
          <hr style={{ margin: '20px 0', border: '2px solid #ddd' }} />
          <div style={{ overflowX: 'auto', maxHeight: '55vh', marginTop: '20px' }}>
            <Table aria-label="simple table">
              <TableHead
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  backgroundColor: "#d0ecf7",
                }}
              >
                  <TableRow>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  SR NO.
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  COMMITTEES NAME
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  MEMBER TYPE
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  MEMBER NAME
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  MOBILE NUMBER
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                  FREEZE
                </TableCell>
              </TableRow>

                </TableHead>
                <TableBody>
              {filteredFreezeData.map((row, index) => (
                <TableRow
                  key={row.id}
                  style={{
                    backgroundColor: row.is_active == 0 ? " #ffcccc" : "none",
                  }}
                >
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                    {index + 1}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                    {row.committee_type}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                    {row.member_type}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                    {row.member_name}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                    {row.mobile_no}
                  </TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <Tooltip title={row.is_active === 1 ? "Unfreeze" : "Freeze"} arrow>
                            <Button
                              variant="contained"
                              color={row.is_active === 1 ? "secondary" : "primary"}
                              onClick={() => handleConfirmFreeze(row.is_freeze, row.id, index)}
                              style={{
                                width: '100px',
                                height: '40px',
                                marginRight: '8px',
                              }}
                            >
                              Freeze
                            </Button>
                          </Tooltip>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
            </div>

        )}
      </div>
      <Dialog
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle style={{fontWeight:"bold"}}>
          Edit Record
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpenEditModal(false)}
            aria-label="close"
            style={{ position: "absolute", right: 15, top: 7 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleEditSubmit}>
            <div className="row g-3">
              <div className="col-md-4">
                <label htmlFor="editCommitteeType" className="form-label" style={{fontWeight:"bold"}}>
                  Committees Name <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-select ${errors.committee_type ? "is-invalid" : ""}`}
                  name="committee_type"
                  id="editCommitteeType"
                  value={editData?.committee_type || ""}
                  onChange={handleEditChange}
                  disabled={editData?.is_active == 0 ? true : false}

                >
                  <option value="" disabled>Select Committee Name</option>
                  {committeName?.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                {errors.committee_type && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {errors.committee_type}
                  </p>
                )}
              </div>

              {othersInput && (
                <div className="col-md-4">
                  <label
                    htmlFor="editCommitteeName"
                    className="form-label"
                    style={{fontWeight:"bold"}}
                  >
                    Committees Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="committeName"
                    className={`form-control ${errors.committeName ? "is-invalid" : ""}`}
                    placeholder="Enter Committee Name"
                    value={editData?.committeName || ""}
                    onChange={handleEditChange}
                    disabled={editData?.is_active == 0 ? true : false}

                  />
                  {errors.committeName && (
                    <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                      {errors.committeName}
                    </p>
                  )}
                </div>
              )}

              <div className="col-md-4">
                <label htmlFor="editMemberType" className="form-label" style={{fontWeight:"bold"}}>
                  Member Type <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-select ${errors.member_type ? "is-invalid" : ""}`}
                  name="member_type"
                  id="editMemberType"
                  value={editData?.member_type || ""}
                  onChange={handleEditChange}
                  disabled={editData?.is_active == 0 ? true : false}

                >
                  <option value="" disabled>Select Member Type</option>
                  {memberType?.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                {errors.member_type && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {errors.member_type}
                  </p>
                )}
              </div>

              <div className="col-md-4">
                <label
                  htmlFor="editMemberName"
                  className="form-label"
                  style={{fontWeight:"bold"}}
                >
                  Member Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.member_name ? "is-invalid" : ""}`}
                  name="member_name"
                  id="editMemberName"
                  value={editData?.member_name || ""}
                  onChange={handleEditChange}
                  placeholder="Enter the Member Name"
                  disabled={editData?.is_active == 0 ? true : false}

                />
                {errors.member_name && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {errors.member_name}
                  </p>
                )}
              </div>

              <div className="col-md-4">
                <label
                  htmlFor="editMobileNo"
                  className="form-label"
                  style={{fontWeight:"bold"}}
                >
                  Mobile No <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.mobile_no ? "is-invalid" : ""}`}
                  name="mobile_no"
                  id="editMobileNo"
                  value={editData?.mobile_no || ""}
                  onChange={handleEditChange}
                  placeholder="Enter the Mobile No"
                  disabled={editData?.is_active == 0 ? true : false}


                />
                {errors.mobile_no && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {errors.mobile_no}
                  </p>
                )}
              </div>

              <div className="d-flex justify-content-end mt-3">
                <Button
                  variant="contained"
                  onClick={() => setOpenEditModal(false)}
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#323576",
                    color: "#ffffff",
                    width: "12%",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  style={{
                    backgroundColor: "#323576",
                    color: "#ffffff",
                    width: "12%",
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog open={openDialog} onClose={handleCancelDelete}>
        <DialogTitle>
          <AlertIcon style={{ color: "red", marginRight: "8px" }} />
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          Are you sure you want to delete this record?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button color="secondary" onClick={handleConfirmDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </div>
  );
};
export default ManageBalSabha;
